import { Location } from '@angular/common';
import { Component, Input, OnInit, OnDestroy, NgZone, ViewChild } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { DomSanitizer } from '@angular/platform-browser';
import { ActivatedRoute, Router } from '@angular/router';
import { IReward } from '../../../../fundraiser/models/fundraiser.model';
import {
  EventsService, FundraiserService, PaymentService, ScriptLoaderService,
  StorageService, VariablesService, CookieService, PusherService, VwoService, PaymentV2Service
} from '../../../../shared/services';
import { ICart } from '../../models/cart.model';
import { IOptions, IPayementGateway } from '../../models/options.model';
import { IOrder } from '../../models/order.model';
import { PaymentUtilService } from '../../services';
import { UtilService } from './../../../../shared/services/util/util.service';
import { environment } from '../../../../../environments/environment';
import { Subscription } from 'rxjs';
import { IUser, IUtmParams } from '../../../../shared/models';
import { FormControl, FormGroup } from '@angular/forms';
import { MatBottomSheet } from '@angular/material/bottom-sheet';
import { GCaptchaComponent } from 'src/app/common/g-captcha/g-captcha.component';
import { IPayConfig } from 'src/app/shared/models/payment.model';

declare const Razorpay;
@Component({
  selector: 'app-options-nav',
  templateUrl: './options-nav.component.html',
  styleUrls: ['./options-nav.component.scss']
})
export class OptionsNavComponent implements OnInit, OnDestroy {
  @ViewChild(GCaptchaComponent, { static: true }) gCaptchaComponent: GCaptchaComponent;

  @Input() config;
  @Input() campaignId;
  @Input() customTag;
  @Input() origin;
  @Input() position;
  @Input() contributeDetails;
  @Input() stripeSwitch;
  @Input() isQR;
  @Input() eventCause;
  @Input() peopleServed;
  @Input() updateId;
  @Input() subscribed;
  @Input() skipFailedCase;
  @Input() payment_method_change = true;
  @Input() sip = false;
  @Input() showOptions = true;
  @Input() isSipStory;

  isMobile: any;
  cartDetails: ICart;
  pCurrency;
  paymentOptions: IPayementGateway;
  options: IOptions[] = [];
  optionRoute;
  activeButton;
  activeOption;
  dataEmitedFromChild;
  upiOptions: any;
  topBanks = [
    { key: 'NB_HDFC', label: 'HDFC' },
    { key: 'NB_AXIS', label: 'AXIS' },
    { key: 'NB_ICICI', label: 'ICICI' },
    { key: 'NB_SBI', label: 'SBI' },
    { key: 'NB_KOTAK', label: 'KOTAK' },
  ];
  isLoading = false;
  isOrderLoading = false;
  reward: IReward;
  qrCodes = {
    paytm: '',
    upi: ''
  };
  optionsDisble;
  generalSubs: Subscription[] = [];
  stripeFailed;
  userdata: IUser;
  tokenUS;
  tyParams;
  searchForm: FormGroup;
  searchText: FormControl;
  bankList;
  submitOrderData;

  captchaResponse = '';

  showStripeLink = false;
  payConfig!: IPayConfig;
  showOneTapPay = false;
  lastOrderData;

  constructor(
    private paymentService: PaymentService,
    private paymentUtilService: PaymentUtilService,
    private actRoute: ActivatedRoute,
    private router: Router,
    public util: UtilService,
    private scriptLoaderService: ScriptLoaderService,
    private storageService: StorageService,
    public dialog: MatDialog,
    public domSanitizer: DomSanitizer,
    public fundraiserService: FundraiserService,
    private eventsService: EventsService,
    public location: Location,
    public zone: NgZone,
    public vars: VariablesService,
    public cookieService: CookieService,
    public pusherService: PusherService,
    public vwo: VwoService,
    public paymentV2: PaymentV2Service,
    public bottomSheet: MatBottomSheet
  ) { }

  ngOnInit() {
    this.isMobile = this.util.isMobile();
    this.upiOptions = this.paymentUtilService.upiOptions;
    if (this.actRoute.snapshot.queryParams.st === 'f' && !this.isQR && !this.skipFailedCase) {
      this.paymentUtilService.initaiteQr = true;
    }
    this.getCart();
    this.actRoute.queryParams.subscribe((param) => this.optionRoute = param);
    this.generalSubs.push(this.paymentUtilService.paymentCurrency.subscribe({ next: res => this.pCurrency = res }));
    this.generalSubs.push(this.paymentUtilService.selectedReward.subscribe({ next: res => this.reward = res }));
    this.generalSubs.push(this.paymentUtilService.paymentOptionsObs.subscribe((res) => this.setDefaultPaymentOption(res)));
    this.generalSubs.push(this.paymentUtilService.miniApps.subscribe((res) => this.submitOrder(res)));
    this.generalSubs.push(this.vars.userData.subscribe((res) => this.userdata = res));
    this.searchForm = new FormGroup({
      searchText: this.searchText = new FormControl(''),
    });
    this.generalSubs.push(this.vars.reload_qr_code.subscribe((res) => {
      if (res) {
        this.qrCodes = { paytm: '', upi: '' };
      }
    }));
    this.generalSubs.push(this.paymentService.onConfigChange$.subscribe(change => {
      this.payConfig = this.paymentService.getConfig();
    }));
  }

  /**Get the cart details */
  getCart() {
    this.generalSubs.push(
      this.paymentUtilService.cartResponse.subscribe({
        next: (res) => {
          if (!res) { return; }
          this.cartDetails = res;
          if ((this.vars.pageName === 'healthfirst_payment_standalone' || this.cartDetails?.resetQR) && !this.isMobile) {
            this.qrCodes.paytm = '';
            this.qrCodes.upi = '';
            this.paymentUtilService.initaiteQr = true;
          }
          if (this.qrCodes && (this.qrCodes.paytm || this.qrCodes.upi)) {
            this.qrCodes = { paytm: '', upi: '' };
            this.setOptionRoute({ name: 'Debit/Credit', route: 'c' });
          }
        }
      })
    );
  }

  /** Set the default payment option after amount form */
  setDefaultPaymentOption(res) {
    if (res && res.options) {
      this.paymentOptions = res;
      this.options = [];
      this.setOptionsObject(res);
      if (this.pCurrency !== 'INR' && !this.isMobile) {
        this.setOptionRoute({ name: 'Debit/Credit', route: 'c' });
      } else if (this.pCurrency === 'INR' && this.isQR) {
        this.setOptionRoute(this.isQR);
        if (!this.isMobile) {
          this.util.arrayMovePosition(this.options, 'name', 'UPI', 0);
        }
      } else if (this.pCurrency === 'INR') {
        if (Object.keys(this.vars.setPaymentOption.getValue()).length !== 0) {
          this.openPaymentTab();
        } else {
          if (!this.isMobile) {
            this.util.arrayMovePosition(this.options, 'name', 'UPI', 0);
            this.setOptionRoute({ name: this.options[0].name, route: this.options[0].route });
          } else {
            this.setOptionRoute({ name: 'Debit/Credit', route: 'c' });
          }
        }
      }
    }
  }

  /**Open the specific payment tab from other pages */
  openPaymentTab() {
    this.generalSubs.push(
      this.vars.setPaymentOption.subscribe({
        next: (res1) => {
          switch (true) {
            case res1.card: this.setOptionRoute({ name: 'Debit/Credit', route: 'c' }); break;
            case res1.netbanking: this.setOptionRoute({ name: 'Net Banking', route: 'nb' }); break;
          }
        }
      })
    );
  }
  /**Set the option values to toggle between the buttons */
  setOptionRoute(option) {
    if (this.activeOption && this.paymentOptions.doNotSetOption && this.paymentUtilService.initaiteQr) {
      option = this.activeOption;
    } else {
      this.activeOption = option;
    }
    this.vars.isOrderLoading = false;
    this.paymentOptions.doNotSetOption = false;
    if (this.cartDetails) {
      const order = {
        iso_currency: this.pCurrency,
        payment_mode: option.name,
        donated_amount: this.cartDetails?.donated_amount_inr,
        tip_amount_inr: this.cartDetails?.tip_amount_inr
      };
      if (!this.sip) {
        this.checkoutGTMEvent(order, 1);
      }
    }
    if (this.options.some(item => item['route'] === option.route)) {
      if (option.name === 'UPI' && !this.qrCodes.upi && this.paymentUtilService.initaiteQr) {
        const data: any = { mode: option.name, mode_value: 'DESKTOPQR' };
        this.submitOrder(data);
      } else if (option.name === 'Paytm' && !this.qrCodes.paytm && this.paymentUtilService.initaiteQr) {
        this.submitOrder({ mode: option.name.toUpperCase(), mode_value: 'DESKTOPQR' });
      }
      this.activeButton = option.route;
    } else {
      this.activeButton = this.options[0]?.route;
    }
  }
  /**Disable other options while donating from UPI */
  disableOptions(data) {
    this.optionsDisble = data;
  }

  /**Go to the route of the inner options of the payment
   * like cards, paytm card etc
   */
  goToInnerRoute(route, mode) {
    const order = {
      iso_currency: this.pCurrency,
      payment_mode: mode,
      donated_amount: this.cartDetails?.donated_amount_inr,
      tip_amount_inr: this.cartDetails?.tip_amount_inr
    };
    this.checkoutGTMEvent(order, 1);
    this.router.navigate([], {
      queryParams: { op: route },
      queryParamsHandling: 'merge'
    });
  }
  /**Get the keys from the object of the options */
  getObjectKeys(obj, name?) {
    if (obj) {
      if (name === 'wallet') {
        for (const key of Object.keys(obj)) {
          obj[key] = obj[key].search('Wallet') === -1 ? obj[key] : obj[key].replace('Wallet', '');
        }
      }
      return this.util.sortArray(Object.keys(obj));
    }
  }
  /**Open select menu for the lits */
  openSelectMenu(template, mode) {
    const order = {
      iso_currency: this.pCurrency,
      payment_mode: mode,
      donated_amount: this.cartDetails?.donated_amount_inr,
      tip_amount_inr: this.cartDetails?.tip_amount_inr
    };
    this.checkoutGTMEvent(order, 1);
    this.router.navigate([], {
      queryParams: { modal: 'list' },
      queryParamsHandling: 'merge'
    });
    this.dialog.open(template, {
      width: '100vw',
      maxWidth: '100vw',
      height: '100%',
      maxHeight: '100vh',
    });
  }
  /**Set the options object according to requirement
   * of the tabs showed in desktop mode
  */
  setOptionsObject(data: IPayementGateway) {
    let i = 0;
    for (const key of Object.keys(data.options)) {
      switch (key) {
        case 'NB':
          this.pushToOptionsArray('Net Banking', 'icon-bank', 'nb', data.options[key], i);
          break;
        case 'CARD':
          this.pushToOptionsArray('Debit/Credit', 'icon-cardsecure', 'c', data.options[key], i);
          break;
        case 'WALLET':
          this.pushToOptionsArray('Wallets', 'icon-wallet', 'w', data.options[key], i);
          break;
        case 'PAYTM':
          this.pushToOptionsArray('Paytm', 'icon-wallet', 'p', data.options[key], i);
          break;
        case 'UPI':
          this.pushToOptionsArray('UPI', 'icon-wallet', 'u', data.options[key], i);
          break;
        default:
          i--;
          break;
      }
      i++;
    }
    this.util.sortArrayOfBject(this.options, 'name');
  }
  /**Makinh itratable array for the tabs */
  pushToOptionsArray(name, icon, route, data, i) {
    if (data) {
      this.options[i] = {
        name: name,
        icon: icon,
        route: route,
        data: data
      };
    }
  }

  /**Submit the netbanking */
  submitOrderMobile(mode, value) {
    if (this.isOrderLoading) {
      return false;
    }
    this.router.navigate([], {
      queryParams: { modal: null },
      queryParamsHandling: 'merge'
    });
    const data = {
      mode: mode,
      mode_value: value
    };
    this.submitOrder(data);
  }
  /**Submit the order */
  submitOrder(data) {
    if (this.vars.selected_insurance && this.cartDetails && this.vars.selected_insurance.plan_amount !== this.cartDetails.donated_amount) {
      this.vars.createCart = true;
      this.cartDetails = null;
    }
    this.submitOrderData = data;

    if (this.vars.createCart && !this.cartDetails) {
      if (this.subscribed && this.config && this.config.pledgeMoreAmount) {
        this.paymentUtilService.createCart(this.config.pledgeMoreAmount, true).then(() => this.submitOrderAPI(data));
      } else if (this.subscribed) {
        this.paymentUtilService.createCart(this.subscribed.amount).then(() => this.submitOrderAPI(data));
      } else if (this.vars.selected_insurance?.plan_amount) {
        this.payment_method_change = false;
        this.paymentUtilService.createCart(this.vars.selected_insurance.plan_amount, false, true).then(() => this.submitOrderAPI(data));
      } else {
        this.util.openSnackBar('You have not subscribed to any SIP yet!', 'error');
      }
    } else if (this.vars.createCartNewUser && !this.cartDetails) {
      this.paymentUtilService.createCart(this.vars.createCartNewUser).then(() => this.submitOrderAPI(data));
    } else {
      this.submitOrderAPI(data);
    }
  }

  submitOrderAPI(data) {
    let pageType = this.vars.pageName || this.vars.campaignType;
    if (this.vars.fundraiser.story_title && this.vars.pageName === 'payment_page') {
      pageType = 'stories';
    }
    this.dataEmitedFromChild = data;
    const utmParams: IUtmParams = this.cookieService.getDecodedCookies('k_utm');
    const payload = {
      'campaign_id': this.cartDetails.campaign_id || this.campaignId,
      'cart_id': this.cartDetails.id,
      'mode': data.mode,
      'gateway': this.paymentOptions.gateway,
      'mode_value': data.mode_value,
      'bin': data.mode === 'CARD' && !data.customer_id && data.card_number_fill ? data.card_number_fill.substr(0, 6) : null,
      'page_type': pageType,
      'ab_testname': this.eventsService.ab.abtestname || '',
      'ab_value': this.eventsService.ab.abvalue || '',
      'vpa': data.VPA || '',
      'tenure': data.tenure || '',
      'payment_gateway': data.payment_gateway || '',
      'is_indian': this.cartDetails.indian || '',
      'cause_id': this.eventCause ? this.eventCause.id : '',
    };

    if (!this.payment_method_change && this.subscribed) {
      payload['subscription_id'] = this.subscribed.id;
    }
    if (this.vars.donateMultiPatient) {
      payload['is_multi_patient_campaign'] = true;
    }
    if (this.vars.fundraiser.support_campaign) {
      payload['support_campaign_id'] = this.vars.fundraiser.support_campaign.id;
    }
    if (this.stripeSwitch && this.pCurrency === 'INR' && !this.stripeFailed) {
      payload.payment_gateway = 'stripe_recurring';
    }
    if (data.donor_pincode) {
      payload['donor_pincode'] = data.donor_pincode;
    }
    if (utmParams) {
      payload['utm_campaign'] = utmParams?.utm_campaign || '';
      payload['utm_medium'] = utmParams?.utm_medium || '';
      payload['utm_source'] = utmParams?.utm_source || '';
      payload['utm_term'] = utmParams?.utm_term || '';
      payload['utm_content'] = utmParams?.utm_content || '';
      payload['utm_placement'] = utmParams?.utm_placement || '';
    }

    if (data.auto_pay_m1) { payload['auto_pay_m1'] = data['auto_pay_m1']; }

    if (data.month_interval) { payload['month_interval'] = data['month_interval']; }

    if (data.ketto_wallet) { payload['ketto_wallet'] = data['ketto_wallet']; }

    if (
      payload['payment_gateway'] === 'stripe_recurring' &&
      this.pCurrency === 'INR' &&
      data.mode === 'CARD' &&
      ['tp'].includes(this.origin) &&
      this.stripeSwitch
    ) {
      this.stripeFailed = true;
      payload['payment_gateway'] = '';
      payload['ketto_wallet'] = 1;
    }

    if (this.cartDetails.sip_cause) { payload['sip_cause'] = this.cartDetails.sip_cause; }
    // if (this.isSipStory) {
    //   payload['transaction_type'] = 'wallet_new_sip_6';
    // }
    if (this.cartDetails?.bulkdonation) {
      payload['bulkdonation'] = this.cartDetails.bulkdonation;
    }

    if (this.vars.selected_insurance?.plan_id) {
      payload['vendor'] = this.vars.selected_insurance?.vendor;
      payload['plan'] = this.vars.selected_insurance?.plan;
      payload['plan_id'] = this.vars.selected_insurance?.plan_id;
      if (this.vars.selectedIllness?.illnessAmount) {
        payload['critical_illness'] = this.vars.selectedIllness.illnessAmount;
      }
    }

    if (this.vars.couponDetails) {
      payload['coupon_code'] = this.vars.couponDetails.coupon_code;
    }

    if (this.vars.selectedKCart?.length > 0) {
      payload['campaign_products'] = this.vars.selectedKCart;
      this.util.storage.check('selectedKCart', this.vars.selectedKCart);
    } else {
      this.util.storage.delete('selectedKCart');
    }

    if (data?.oneTapPay) {
      payload['repeat_donor'] = 1;
      payload['card_no'] = data?.card_no;
      payload['customer_id'] = data?.customer_id;
    }

    if (data?.mode === 'UPI' && data?.mode_value === 'DESKTOPQR' && this.vwo.phonepe_qr_AB()) {
      payload['payment_gateway'] = 'phonepe';
    }

    if(this.vars.supportFee && this.vwo.support_fee_AB() && !this.sip){
      payload['support_fee_ab'] = 1;
    }

    if (data?.vpa_type) {
      payload['vpa_type'] = data?.vpa_type;
    }

    this.placeOrderAPI(payload, data);
  }

  /**Get the options available for the payment */
  getPaymentOptions(currency) {
    this.paymentService.setConfig({optionsResponse: undefined});
    this.paymentService.getPaymentOptions(currency).subscribe((res: any) => {
      this.paymentOptions = res.data;
      this.paymentService.setConfig({optionsResponse: res.data});
      this.setOptionsObject(res.data);
    });
  }
  /**Place order API call */
  placeOrderAPI(payload, data?) {
    this.isOrderLoading = true;
    this.vars.isOrderLoading = true;
    if (payload?.vpa && this.vars.recommendedVpa && payload?.vpa !== this.vars.recommendedVpa) {
      this.eventsService.sendSystemEvent({
        eventName: 'vpa_changed',
        info_1: 'new vpa = ' + payload?.vpa,
        info_2: 'old vpa = ' + this.vars.recommendedVpa
      }).subscribe(_ => _);
    }
    this.paymentService.placeOrder(payload, this.cartDetails.campaign_id || this.campaignId).subscribe(async (res: any) => {
      const orderRes = res;
      if (data.auto_pay_m1) {
        orderRes['data']['auto_pay_m1'] = data.auto_pay_m1;
      }
      await this.trackingEvents(orderRes.data);
      if (orderRes.data.payment_mode.match('UPI|PAYTM')) {
        this.vars.currentOrderId = res.data.order_id;
        this.pusherService.sendOrderId = true;
        this.pusherService.activateUPIPusher(res.data);
      }
      this.storageService.checkFromSession(res.data.order_id, this.cartDetails);
      if (orderRes.data.payment_gateway.match('stripe|stripeindia') && orderRes?.data?.payment_mode !== 'LINK' && !data?.oneTapPay) {
        this.stripePayment(orderRes, data);
      } else if (orderRes.data.payment_gateway.match('juspay') && orderRes.data.payment_mode === 'CARD') {
        this.juspayCheck(orderRes);
      } else {
        this.sendOrder(orderRes.data, data);
      }
    }, (err: any) => {
      this.isOrderLoading = false;
      this.vars.isOrderLoading = false;
      if (err?.error?.message?.match('Invalid card number')) {
        this.vars.oneTapPayError.next('invalid');
      } else if (err?.error?.message?.match('Limit exceeded')) {
        this.vars.oneTapPayError.next('limit_exceed');
      }
      if (payload?.vpa) {
        this.vars.showTimer = false;
        this.vars.upi_payment_status.next('failed');
      }
    });
  }
  /**Payment initiate using stripe */
  stripePayment(orderRes, data) {
    if (this.stripeSwitch && this.pCurrency === 'INR') {
      this.stripeSwitchForRecurringDonations(orderRes, data);
    } else if (this.stripeSwitch && this.pCurrency !== 'INR' && data.customer_id) {
      this.sendOrder(orderRes.data, { customer_id: data.customer_id, save_card: this.dataEmitedFromChild.save_card });
    } else {
      this.getStripeToken(orderRes);
    }
    // else if ((!this.stripeSwitch && this.pCurrency === 'INR') || (!this.stripeSwitch && this.pCurrency !== 'INR' && data.customer_id)) {
    //   this.stripeSwitchForOneTimeDonations(orderRes, data);
    // }
  }
  /** Get Stripe Token and return */
  async getStripeToken(orderRes, key = this.paymentOptions.setting.stripe.key) {
    try {
      const token = await this.createStripeCardToken(this.dataEmitedFromChild, key);
      this.sendOrder(orderRes.data, { token: token, save_card: this.dataEmitedFromChild.save_card });
    } catch (error) {
      this.util.openSnackBar(error.message, 'error');
      this.isOrderLoading = false;
      this.vars.isOrderLoading = false;
    }
  }
  /** Switch to stipe and create token for one time donations */
  async stripeSwitchForOneTimeDonations(orderRes, data?) {
    try {
      if (data.customer_id) {
        this.sendOrder(orderRes.data, { customer_id: data.customer_id });
      } else {
        this.tokenUS = await this.createStripeCardToken(this.dataEmitedFromChild, this.paymentOptions?.setting?.stripe?.key_us);
        const tokenInr = await this.createStripeCardToken(this.dataEmitedFromChild, this.paymentOptions.setting.stripe.key);
        this.sendOrder(orderRes.data, { token: tokenInr, save_card: this.dataEmitedFromChild.save_card });
      }
    } catch (error) {
      this.util.openSnackBar(error.message, 'error');
      this.isOrderLoading = false;
      this.vars.isOrderLoading = false;
    }
  }
  /** Recuring donation switch on the basis of customer_id/us_token/fresh donation */
  stripeSwitchForRecurringDonations(orderRes, data) {
    if (data.customer_id) {
      if (this.vars.stripeUsToken && !this.stripeFailed) {
        this.sendOrder(orderRes.data, { token: this.vars.stripeUsToken, save_card: this.dataEmitedFromChild.save_card });
      } else {
        this.sendOrder(orderRes.data, { customer_id: data.customer_id, save_card: this.dataEmitedFromChild.save_card });
      }
    } else {
      if (!this.stripeFailed) {
        this.getStripeToken(orderRes, this.paymentOptions?.setting?.stripe?.key_us);
      } else {
        this.getStripeToken(orderRes);
      }
    }
  }
  /**Create stripe token */
  createStripeCardToken(card, key = this.paymentOptions.setting.stripe.key) {
    return new Promise(async (resolve, reject) => {
      try {
        const cardPayload = {
          key: key,
          'card[number]': card.card_number_fill,
          'card[cvc]': card.card_cvv_fill,
          'card[exp_month]': card.card_month_fill,
          'card[exp_year]': card.card_year_fill
        };
        this.paymentService.createStripeToken(cardPayload).subscribe({
          next: (res: any) => {
            // console.log(res);
            resolve(res.id);
          },
          error: (err: any) => {
            // console.log(err);
            reject(err?.error?.error);
          }
        });
      } catch (error) {
        reject(false);
      }
    });
  }
  /**Check juspay condition
   * if payment gateway is juspay token is required for payment usgin card
   * */
  juspayCheck(orderRes) {
    this.dataEmitedFromChild['merchant_id'] = this.paymentOptions.setting.juspay.key;
    this.scriptLoaderService.load('jquery').then(() => {
      this.scriptLoaderService.load('juspay').then(() => {
        this.sendOrder(orderRes.data);
      });
    });
  }
  /**Send the order to the for gateway respnse */
  sendOrder(order: IOrder, data?) {
    const payload = {
      'order_id': order.order_id,
      // tslint:disable-next-line:max-line-length
      'return_url': this.util.domain_details.domain_url + environment.base_ref + `payment-route?or=${this.origin}&id=${this.cartDetails.campaign_id || this.campaignId}&oi=${order.order_id}&ct=${this.customTag}&pcurrency=${order.iso_currency}`,
      'token': data && data.token ? data.token : '',
      'token_1': this.tokenUS || '',
      'save_card': data && data.save_card ? data.save_card : '',
      'customer_id': data && data.customer_id ? data.customer_id : null,
      'account_no': data && data.bank_account ? data.bank_account : '',
      'ifsc_code': data && data.bank_ifsc ? data.bank_ifsc : '',
      'bank_code': data && data.bank_code ? data.bank_code : '',
      'bank_name': data && data.bank_name ? data.bank_name : ''
    };
    const queryParams = this.actRoute.snapshot.queryParams;
    if (data && data.auth_mode) {
      payload['auth_mode'] = data.auth_mode;
    }
    // Adding cause to url
    if (this.vars.fundraiser && this.vars.fundraiser.cause) {
      payload['return_url'] = payload['return_url'].concat(`&cause=${this.vars.fundraiser.cause.info_1}`);
    }
    if (this.vars.createCart) {
      payload['return_url'] = payload['return_url'].concat(`&email=${this.userdata.email}`);
      payload['payment_method_change'] = this.payment_method_change ? this.subscribed?.id : null;
    }
    if (this.vars.thirdPartyApp) {
      payload['return_url'] = payload['return_url'].concat('&social=0&payops=0&utm_source=phonepe');
    }
    if (this.eventCause && this.eventCause.id) {
      payload['return_url'] = payload['return_url'].concat(`&eventPage=true&ward_id=${this.eventCause.id}&served=${this.peopleServed}&ward_name=${this.eventCause.info_4}`);
    }
    if (this.updateId) {
      payload['return_url'] = payload['return_url'].concat(`&fmd_id=${queryParams.fmd_id}&update_id=${this.updateId}&action_date=${queryParams.action_date}&donated_amount=${queryParams.donated_amount}&donated_currency=${queryParams.donated_currency}&is_donor=${queryParams.is_donor}`);
    }
    if (queryParams.ord === 'f') {
      payload['return_url'] = payload['return_url'].concat(`&pn=${queryParams.pn}&amt=${order.donated_amount}&ord=f`);
    }
    if (this.router.url.match('new/thankyou|new/kettokart/thankyou')) {
      payload['return_url'] = payload['return_url'].concat(`&typOr=${queryParams.or}`);
    }
    if (this.router.url.match('new/sip/welcome') || this.router.url.match('new/sip/payment-standalone')) {
      payload['return_url'] = payload['return_url'].concat(`&amt=${order.donated_amount}`);
    }
    if (queryParams.utm_campaign && queryParams.utm_campaign.includes('mbm')) {
      payload['return_url'] = payload['return_url'].concat(`&utm_campaign=${queryParams.utm_campaign}`);
    }
    if (queryParams.offer) {
      payload['return_url'] = payload['return_url'].concat(`&offer=${queryParams.offer}`);
    }
    const donorType = this.userdata && this.userdata.aggdonationall && this.userdata.aggdonationall?.funds ? 'rp' : 'fs';
    // tslint:disable-next-line: max-line-length
    payload['return_url'] = payload['return_url'].concat(`&dnr=${donorType}&lpm=${order.payment_gateway.match('stripe') ? 'strp' : 'nstrp'}`);

    if (this.submitOrderData && this.submitOrderData.lastPaymentBank) { payload['return_url'] = payload['return_url'] + `&lpb=${this.submitOrderData.lastPaymentBank}`; }
    if (this.submitOrderData && this.submitOrderData.mode) { payload['return_url'] = payload['return_url'] + `&last_pay_mode=${this.submitOrderData.auth_mode || this.submitOrderData.mode}`; }

    if ((data && data.auto_pay_m1) || order.auto_pay_m1) { payload['return_url'] = payload['return_url'] + `&auto_pay_m1=1`; }

    // Thank you page params
    this.vars.tyParams = {
      id: this.cartDetails.campaign_id || this.campaignId,
      or: this.origin,
      oi: order.order_id,
      dnr: donorType,
      lgm: order.payment_gateway.match('stripe') ? 'strp' : 'nstrp',
      offer: queryParams.offer || null,
      ct: this.customTag
    };

    if (this.config && this.config.pledgeMoreAmount) {
      payload['return_url'] = payload['return_url'] + `&amt=${this.config.pledgeMoreAmount}&pledgeMore=1`;
      this.vars.tyParams['pledgeMore'] = 1;
    }

    if (queryParams.coupon) {
      payload['return_url'] = payload['return_url'] + `&coupon=${queryParams.coupon}`;
      this.vars.tyParams['coupon'] = queryParams.coupon;
    }

    if (queryParams.month_interval) {
      this.vars.tyParams['month_interval'] = queryParams.month_interval;
      payload['return_url'] = payload['return_url'] + `&month_interval=${queryParams.month_interval}`;
    }

    if (this.isSipStory && !this.userdata.subscribed) {
      this.vars.tyParams['sip_story'] = 1;
      payload['return_url'] = payload['return_url'] + `&sip_story=1`;
    }

    if (this.optionRoute?.min_donation) {
      this.vars.tyParams['min_donation'] = +this.optionRoute?.min_donation;
      payload['return_url'] = payload['return_url'] + `&min_donation=${+this.optionRoute?.min_donation}`;
    }

    if (queryParams.mini_story) {
      payload['return_url'] = payload['return_url'] + `&mini_story=${queryParams.mini_story}`;
      this.vars.tyParams['mini_story'] = queryParams.mini_story;
    }

    if (queryParams.utm_source) {
      payload['return_url'] = payload['return_url'] + `&${this.util.utm_url_string}`;
      this.vars.tyParams = { ...this.vars.tyParams, ...this.util.utm_url_obj };
    }

    if (order?.tip_amount && this.origin === 'tp') {
      payload['return_url'] = payload['return_url'] + `&tip_amount=${order?.tip_amount}`;
      this.vars.tyParams['tip_amount'] = order?.tip_amount;
    }

    if (queryParams?.utm_source?.match('otd_calling') && queryParams?.mini_story) {
      payload['return_url'] = payload['return_url'] + `&ministoryquiz=true`;
      this.vars.tyParams['ministoryquiz'] = 'true';
    }

    if (this.vars.selected_insurance?.plan) {
      payload['return_url'] = payload['return_url'] + `&vendor=${this.vars.selected_insurance.vendor}&plan=${this.vars.selected_insurance.plan}`;
      this.vars.tyParams['vendor'] = this.vars.selected_insurance.vendor;
      this.vars.tyParams['plan'] = this.vars.selected_insurance.plan;
      if (queryParams.pledge_more) {
        payload['return_url'] = payload['return_url'] + `&pledge_more=${queryParams.pledge_more}`;
        this.vars.tyParams['pledge_more'] = queryParams.pledge_more;
      }
    }

    if ((order?.tip_amount === 0 && this.origin === 'f' && this.vars?.fundraiser.tip_model) || queryParams.frtip === 'true' || this.vars?.pageName === 'standalonetip') {
      payload['return_url'] = payload['return_url'] + `&frtip=true`;
      this.vars.tyParams['frtip'] = true;
    }

    if (this.vars.selectedIllness?.person) {
      payload['return_url'] = payload['return_url'] + `&person=${this.vars.selectedIllness.person}&cover=${this.vars.selectedIllness.cover_count}&cover_amount=${this.vars.selectedIllness.illnessAmount}`;
      this.vars.tyParams['person'] = this.vars.selectedIllness.person;
      this.vars.tyParams['cover'] = this.vars.selectedIllness.cover_count;
      this.vars.tyParams['cover_amount'] = this.vars.selectedIllness.illnessAmount;
    }

    if (this.vars.couponDetails) {
      payload['return_url'] += `&coupon_code=${this.vars.couponDetails.coupon_code}`;
      this.vars.tyParams['coupon_code'] = this.vars.couponDetails.coupon_code;
    }

    if (this.vars.fundraiser.is_multi_patient_campaign) {
      payload['return_url'] += `&multi_patient_opted=${this.vars.donateMultiPatient || 0}`;
      this.vars.tyParams['multi_patient_opted'] = this.vars.donateMultiPatient || 0;
    }

    if (order?.sub_campaign_id) {
      payload['return_url'] += `&sub_campaign_id=${order?.sub_campaign_id}`;
      this.vars.tyParams['sub_campaign_id'] = order?.sub_campaign_id;
    }

    if (this.vars.selectedOtdSipAmt) {
      payload['return_url'] += `&otd_sip=${this.vars.selectedOtdSipAmt}`;
      this.vars.tyParams['otd_sip'] = this.vars.selectedOtdSipAmt;
      this.util.storage.checkFromSession('orderData', order);
    }

    if (queryParams?.entity_type) {
      payload['return_url'] = payload['return_url'].concat(`&entity_type=${queryParams.entity_type}`);
      this.vars.tyParams['entity_type'] = queryParams.entity_type;
    }


    if (data && data.manual) {
      this.goToThankYouPage(order);
      return;
    }

    this.vars.paymentOrigin = this.origin;
    this.paymentService.setConfig({ sendPayoad: payload });

    this.paymentService.sendOrder(payload).subscribe(async (res: any) => {
      this.vars.showTimer = true;
      this.storageService.deleteFromSession('payment_return_params');
      if (res?.data?.charged === false && order?.payment_mode === 'LINK' && res?.data?.params?.client_secret) {
        this.paymentService.setConfig({ sendResponse: res?.data });
        this.vars.isOrderLoading = false;
        this.isOrderLoading = false;
        return;
      }

      if (res.data.charged) {
        if (res.data.status === 'success') {
          let activeSips = this.util.getActiveSip(this.util.getUserData()?.listsubscriptions);
          if (this.vars.selectedOtdSipAmt && !activeSips?.includes('medical')) {
            this.otdToSip(order);
          } else {
            this.goToThankYouPage(order);
          }
        } else if (res.data.status === 'failed') {
          // failed route here
        }
      } else if (res.data.charged === false) {

        if (order.payment_gateway === 'razorpay') {
          if (res.data.UPI && this.isMobile && !order.private_key) {
            this.util.nativeNavigation(res.data.url);
            this.vars.upiTimer = true;
          } else if (order.payment_mode_value === 'DESKTOPQR') {
            this.qrCodes.upi = res?.data?.params?.upi?.message;
          } else {
            this.scriptLoaderService.load('razor_pay_custom_checkout').then(() => {
              this.razorpayCustomCheckoutPayment(order, res.data.params);
            });
            return;
          }
          this.vars.isOrderLoading = false;
          this.isOrderLoading = false;
          return;
        }

        if (res.data.UPI) {
          if ((order.payment_gateway === 'phonepe' || order.payment_gateway === 'payu') && order?.payment_mode_value !== 'DESKTOPQR') {
            if (this.isMobile && res.data.url) {
              this.util.nativeNavigation(res.data.url);
            } else {
              this.vars.upiTimer = true;
            }
            this.pusherService.vpaTxnStatus({
              order_id: order.order_id,
              origin: this.dataEmitedFromChild.origin
            });
            this.isOrderLoading = false;
            this.vars.isOrderLoading = false;
          } else if (this.isMobile) {
            this.util.nativeNavigation(res.data.url);
            this.isOrderLoading = false;
            this.vars.isOrderLoading = false;
            this.vars.upiTimer = true;
          } else {
            if (order.payment_mode_value === 'DESKTOPQR') {
              if (order.payment_mode === 'UPI') {
                this.qrCodes.upi = res?.data?.params?.upi?.message;
              }
              if (order.payment_mode === 'PAYTM') {
                this.qrCodes.paytm = res.data.params.paytm.message;
              }
              this.isOrderLoading = false;
              this.vars.isOrderLoading = false;
            }
          }
        } else if ((res.data.hasOwnProperty('pg_txn_id')) && order.payment_mode_value === 'VPA') {
          this.pusherService.vpaTxnStatus({
            order_id: order.order_id,
            origin: this.dataEmitedFromChild.origin
          });
          this.vars.upiTimer = true;
          this.isOrderLoading = false;
          this.vars.isOrderLoading = false;
        } else if (order.payment_mode === 'PAYTMMA') {
          const requestObject = {
            'amount': res.data.params.TXN_AMOUNT.toString(),
            'orderId': order.order_id,
            'txnToken': res.data.params.TXN_TOKEN,
            'mid': res.data.params.MID,
          };
          this.paymentService.isPaytmReady(() => {
            (<any>window).JSBridge.call('paytmPayment', requestObject, (result) => {
              this.zone.run(() => {
                const paytmPaymentRes = result && result.data ? JSON.parse(result.data) : result;
                if (paytmPaymentRes.STATUS === 'TXN_SUCCESS') {
                  this.dialog.closeAll();
                  this.router.navigate(['/new/payment-route'], { queryParams: this.vars.tyParams });
                } else {
                  this.isOrderLoading = false;
                  this.vars.isOrderLoading = false;
                  this.util.openSnackBar('Please try again', 'error');
                }
              });
            });
          });
        } else if (order.payment_mode_value === 'Emandate' && order.payment_gateway === 'razorpay_emandate') {
          this.scriptLoaderService.load('razor_pay').then(() => {
            this.startRazorPayment(order, res.data.params);
          });
        } else {
          this.submitToPaymentGateway(res, order, payload);
        }
      }
    }, (error) => {
      this.isOrderLoading = false;
      this.vars.isOrderLoading = false;
      this.vars.showTimer = false;
      if (order.payment_gateway === 'stripe_recurring' && this.pCurrency === 'INR' && order.payment_mode === 'CARD' && this.stripeSwitch) {
        this.stripeFailed = true;
        this.submitOrder(this.dataEmitedFromChild);
      } else {
        this.stripeFailed = false;
      }
      if (order.payment_gateway === 'phonepe') {
        this.vars.upi_payment_status.next('failed');
      }
    });
  }
  /**Submit foem to gateway */
  submitToPaymentGateway(res, order: IOrder, sendOrderPayload) {
    // tslint:disable-next-line:prefer-const
    let sendOrderRes = res.data;
    if (sendOrderRes.params) {
      for (const item of Object.entries(sendOrderRes.params)) {
        if (this.dataEmitedFromChild.hasOwnProperty(item[1])) {
          sendOrderRes.params[item[0]] = this.dataEmitedFromChild[item[1].toString()];
        }
      }
    }
    if (order.payment_mode === 'Simpl') {
      sendOrderRes.url = sendOrderRes.url + `&merchant_payload=${JSON.stringify({ return_url: encodeURIComponent(sendOrderPayload.return_url) })}`;
      this.util.nativeNavigation(sendOrderRes.url);
    } else {
      if (!sendOrderRes?.url) {
        this.isOrderLoading = false;
        this.vars.isOrderLoading = false;
        this.vars.showTimer = false;
        this.util.openSnackBar(sendOrderRes?.message || 'something went wrong please try again', 'error');
        this.disableOptions(false);
        return;
      }
      this.paymentService.submitToPaymentGateway(sendOrderRes, this.paymentOptions.gateway, this.dataEmitedFromChild.mode);
    }
  }

  /**Start Razor payment intent */
  startRazorPayment(order, sendOrderRes) {
    const options = {
      key: this.paymentOptions.setting.razorpay.key,
      order_id: sendOrderRes.recurring_order_id,
      customer_id: sendOrderRes.customer_id,
      recurring: '1',
      modal: {
        ondismiss: () => {
          this.zone.run(() => {
            this.isOrderLoading = false;
            this.vars.isOrderLoading = false;
          });
        }
      },
      handler: (response) => {
        this.zone.run(() => {
          const qParams = { ...response, ...this.vars.tyParams };
          this.router.navigate(['/new/payment-route'], { queryParams: qParams });
        });
      },
      notes: {
        order_id: order.order_id,
        camp_id: order.campaign_id
      },
      theme: {
        color: '#01bfbd'
      }
    };
    const rzp1 = new Razorpay(options);
    rzp1.open();
  }

  razorpayCustomCheckoutPayment(order: IOrder, sendOrderRes) {
    const razConfig = {
      key: this.paymentOptions.setting.razorpay.key,
      image: `${environment.APP.IMAGE_DOMAIN}/images/logo-light-bg.svg`
    };
    const razorpay = new Razorpay(razConfig);
    const payload = {
      amount: sendOrderRes.amount,
      currency: sendOrderRes.currency?.toUpperCase() || null,
      email: sendOrderRes.email,
      contact: sendOrderRes.contact,
      order_id: sendOrderRes.order_id,
      method: '',
      notes: {
        order_id: order.order_id,
        camp_id: order.campaign_id
      }
    };

    if (order.payment_mode === 'CARD') {
      payload.method = 'card';
      payload['card'] = {
        name: order.donor_first_name,
        number: this.dataEmitedFromChild.card_number_fill,
        cvv: this.dataEmitedFromChild.card_cvv_fill,
        expiry_month: this.dataEmitedFromChild.card_month_fill,
        expiry_year: this.dataEmitedFromChild.card_year_fill
      };
    } else if (order.payment_mode === 'NB') {
      payload.method = 'netbanking';
      payload['bank'] = sendOrderRes.bankcode;
    } else if (order.payment_mode === 'UPI' && order.checksum) {
      payload.method = 'upi';
      payload['vpa'] = order.checksum;
    } else if (order.payment_mode === 'WALLET') {
      payload.method = 'wallet';
      payload['wallet'] = order.payment_mode_value?.toLowerCase();
    }

    razorpay.createPayment(payload);
    if (order.payment_mode !== 'UPI') {
      razorpay.on('payment.success', (resp) => {
        this.isOrderLoading = false;
        this.vars.isOrderLoading = false;
        Object.assign(this.vars.tyParams, resp);
        this.util.router.navigate(['/new/payment-route'], { queryParams: this.vars.tyParams });
        this.dialog.closeAll();
        this.bottomSheet.dismiss();
      });
    }
    razorpay.on('payment.error', (error) => {
      this.razorpayFailedPayment(error?.error);
    });
  }

  razorpayFailedPayment(error) {
    this.disableOptions(false);
    this.isOrderLoading = false;
    this.vars.isOrderLoading = false;
    this.vars.tyParams = {
      ...this.vars.tyParams,
      razorpay_payment_id: error?.metadata?.payment_id || '',
      razorpay_order_id: error?.metadata?.order_id || '',
      source: error?.source || '',
      reason: error?.description || '',
      showError: 'false'
    }
    this.util.openSnackBar(error?.description, 'error');
    this.paymentService.getOrderStatusAfterPayment(this.vars.tyParams).subscribe({
      next: (success) => {
        console.log('success', success);
        this.util.router.navigate(['/new/payment-route'], { queryParams: this.vars.tyParams });
      },
      error: (err) => {
        this.paymentFailedEvent(err?.error);
      }
    });
  }

  paymentFailedEvent(error) {
    const pageEvent = {
      eventName: 'payment_response',
      event_type: 'payment',
      // event_type_id: this.vars.tyParams['oi'],
      page_name: 'payment-redirect-page',
      info_1: 'failed',
      info_2: this.vars.tyParams['oi'],
      info_3: JSON.stringify(this.vars.tyParams),
      info_4: error?.message || '',
    };
    this.eventsService.sendSystemEvent(pageEvent).subscribe(_ => _);
  }

  /** Razorpay card payment intent */
  razorpayCardPaymnt(order: IOrder, sendOrderRes, cardDetails) {
    const razorpay = new Razorpay({
      key: this.paymentOptions.setting.razorpay.key,
      amount: order.donated_amount,
      name: 'Ketto',
      image: `https://dev2.ketto.org/assets/logo.svg`
    });
    razorpay.createPayment({
      amount: sendOrderRes.amount,
      email: sendOrderRes.email,
      contact: sendOrderRes.contact,
      order_id: sendOrderRes.order_id,
      method: 'card',
      'card[name]': order.donor_first_name,
      'card[number]': cardDetails.card_number_fill,
      'card[cvv]': cardDetails.card_cvv_fill,
      'card[expiry_month]': cardDetails.card_month_fill,
      'card[expiry_year]': cardDetails.card_year_fill
    });
    razorpay.on('payment.success', (resp) => {
      this.zone.run(() => {
        Object.assign(this.vars.tyParams, resp);
        this.router.navigate(['/new/payment-route'], { queryParams: this.vars.tyParams });
        this.dialog.closeAll();
      });
    });
    razorpay.on('payment.error', (resp) => {
      this.isOrderLoading = false;
      this.vars.isOrderLoading = false;
      this.util.openSnackBar(resp.error.description, 'error');
    });
  }

  /** Redirect to thank you page after succuessfull payment on cards */
  goToThankYouPage(order: IOrder) {
    this.zone.run(() => {
      const url = this.vars.showKCart ? '/new/kettokart/thankyou' : '/new/thankyou';
      this.router.navigate([url], { queryParams: this.vars.tyParams }).then(() => this.dialog.closeAll());
      this.storageService.deleteFromSession(order.order_id);
      this.paymentUtilService.cartResponse.next(null);
      this.paymentV2.paymentConfig.next(null);
      this.paymentV2.sheet.dismiss();
    });
  }

  /**ALL THE TRACKING EVENTS PUSH */
  trackingEvents(order) {
    // Returning promise because page was redirecting to send order before system event completes
    return new Promise((resolve, reject) => {
      try {
        const claverTap = {
          'id': this.cartDetails.campaign_id || this.campaignId,
          'Step': 3,
          'Name': this.cartDetails.donor_name,
          'Email': this.cartDetails.donor_email,
          'Amount': order.donated_amount_local,
          'Payment Mode': order.payment_mode,
          'Type_AB': 'typeAB',
          'Page Name': this.vars.campaignType || '',
          'TipAmount': order.tip_amount_local,
          'Iso Currency': order.iso_currency,
          'Cart ID': this.cartDetails.id,
          'Recurring': this.cartDetails.recurring ? true : false
        };

        if (this.vars.fundraiser) {
          claverTap['Custom Tag'] = this.vars.fundraiser.custom_tag;
          claverTap['Parent Cause Id'] = this.vars.fundraiser.parent_cause_id;
        }

        this.checkoutGTMEvent(order, 2);
        if (this.reward) {
          claverTap['Reward'] = this.reward.id;
        }

        this.eventsService.claverTapPush('New Contribution Step 3', claverTap);
        let info1 = this.vars.event_info.info_1 || this.position || '';
        if (this.vars.selectedIllness?.illnessAmount) {
          info1 = `${JSON.stringify(this.contributeDetails.slabs)}/${this.vars.selectedIllness.person}; ${this.vars.selectedIllness.illnessAmount}`;
        } else if (this.contributeDetails && this.contributeDetails.slabs) {
          info1 = `${JSON.stringify(this.contributeDetails.slabs)}/${order.donated_amount}`;
        }

        if (this.vars.selectedKCart) {
          info1 = this.paymentUtilService.getSelectedProductAsInfo();
        }

        const systemEvent = {
          'eventName': 'order_created',
          'event_type': 'campaign',
          'event_type_id': this.cartDetails.campaign_id || this.campaignId,
          'page_name': this.vars.pageName || '',
          'info_1': info1,
          'info_2': order.id,
          'info_3': this.vars.event_info.info_3 || this.vars.campaignType,
          'info_4': this.vars?.event_info?.info_4 || this.vars?.system_event?.order_created?.info_4 || ''
        };

        if (this.vars.fundraiser?.is_multi_patient_campaign && this.vars.pageName.match('stories|mini_story')) {
          systemEvent.info_3 += this.vars.donateMultiPatient ? ',multi_p_enabled' : ',multi_p_disabled';
        }

        this.eventsService.sendSystemEvent(systemEvent).subscribe(
          (next) => resolve(true),
          (err) => resolve(err)
        );
      } catch (error) {
        reject(false);
      }
    });
  }

  checkoutGTMEvent(order, step) {
    const gtmCheckout = {
      'event': 'checkout',
      'sip': this.sip,
      'value': order.donated_amount,
      'currency': order.iso_currency,
      'ecommerce': {
        'checkout': {
          'actionField': { 'step': step, 'option': order.payment_mode },
          'products': [{
            'name': this.vars.fundraiser.custom_tag, // Campaign Name
            'id': this.vars.fundraiser.id, // Campaign ID.
            'category': this.util.getCampaignTypeFromId(this.vars.fundraiser.parent_cause_id),  // Campaign Type
            'variant': this.vars.fundraiser.cause_id,
            'price': order.donated_amount,
            'quantity': 1,
            'dimension5': '', // cd_Fundraiser Attributes
            'dimension6': order.iso_currency,
            'dimension7': this.vars.fundraiser.cause_id, // cd_Campaign Cause ID
            'dimension8': this.vars.fundraiser.custom_tag, // cd_Campaign Custom Tag
            'dimension9': this.vars.fundraiser.id, // cd_Campaign ID
            'dimension10': this.util.getCampaignTypeFromId(this.vars.fundraiser.parent_cause_id), // cd_Campaign Type
            'dimension15': order.donated_amount, // cd_Donation Amount
            'dimension16': this.vars.selectTipPercentage || '', // cd_Tip Percentage
            'dimension17': order.tip_amount_inr // cd_Tip Amount
          }]
        }
      }
    };
    this.eventsService.gtmPush(gtmCheckout);
    this.eventsService.fbPixelPush('AddPaymentInfo', {});
  }


  search(value) {
    if (!this.bankList) {
      this.bankList = this.paymentOptions.options.NB;
    }
    this.paymentOptions.options.NB = this.util.filterObject(this.bankList, value);
  }

  gotCaptchaResponse(e) {
    this.captchaResponse = e;
    this.otdToSip();
  }

  async otdToSip(order?) {
    if (order && order?.iso_currency !== 'INR' && !this.captchaResponse) {
      this.eventsService.sendSystemEvent({
        eventName: 'otd_to_sip_started',
        info_1: 'waiting_for_captcha'
      }).subscribe(_ => _);
      this.util.storage.checkFromSession('orderData', order);
      this.gCaptchaComponent.executeCaptcha();
      return;
    } else if (!order) {
      order = this.util.storage.getFromSession('orderData');
    }
    const oneTapPayload = {
      origin: this.origin,
      currency: order?.iso_currency,
      amount: this.vars.selectedOtdSipAmt,
      donor_email: this.cartDetails?.donor_email,
      donor_extension: this.cartDetails?.donor_extension,
      donor_name: this.cartDetails?.donor_name || order?.donor_first_name,
      donor_phone: this.cartDetails?.donor_phone,
      sip_cause: [{ sip_cause: this.vars.default_sip_cause, amount: this.vars.selectedOtdSipAmt }],
      captchaResponse: this.captchaResponse
    };
    if (await this.paymentV2.oneTapSip(oneTapPayload)) {
      this.vars.tyParams['otd_sip_success'] = true;
    };
    this.captchaResponse = '';
    this.goToThankYouPage(order);
  }

  onStripeExpressReady(e) {
    console.log(e);
    Object.keys(e).forEach(val => {
      if (e[val]) { this.showStripeLink = true; }
    });

    if (this.showStripeLink) {
      this.lastOrderData = this.vars.lastOrderInfo.getValue();
      const isLoggedIn = this.util.isLoggedIn.getValue();
      if (isLoggedIn && this.lastOrderData?.last4 && this.lastOrderData?.iso_currency !== 'INR' && this.pCurrency !== 'INR') {
        this.showOneTapPay = true;
        this.vars.oneTapPayError.subscribe(val => {
          if (val === 'limit_exceed') {
            this.showOneTapPay = false;
          }
        });
      } else {
        this.showOneTapPay = false;
      }
    }
  }

  onStripeCheckoutClick(e) {
    this.submitOrder({ mode: 'LINK', mode_value: e?.expressPaymentType });
    console.log(e);
  }

  ngOnDestroy() {
    this.paymentUtilService.cartSubs.forEach(s => s.unsubscribe());
    this.paymentUtilService.initaiteQr = false;
    this.generalSubs.forEach(s => s.unsubscribe());
  }
}
